// Environment variables are injected at build time by React
declare const process: {
  env: {
    REACT_APP_API_URL?: string;
    NODE_ENV: string;
  };
};

export const BACKEND_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";